package com.checkin.host.ui.auth

import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.remember
import com.checkin.host.util.googleClientId
import kotlinx.browser.document
import kotlinx.browser.window
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Text
import org.w3c.dom.HTMLElement
import kotlin.random.Random

private var credentialHandler: ((String) -> Unit)? = null

@Composable
fun GoogleSignInSection(
    enabled: Boolean,
    onCredential: (String) -> Unit,
) {
    val clientId = remember { googleClientId() } ?: return
    val buttonId = remember { "google-signin-${Random.nextInt()}" }

    DisposableEffect(clientId, onCredential) {
        credentialHandler = onCredential
        window.asDynamic().checkinHandleGoogleCredential = { credential: String ->
            credentialHandler?.invoke(credential)
        }

        var cancelled = false
        fun mountButton() {
            if (cancelled) return
            val google = window.asDynamic().google
            if (google == null || google.accounts == undefined) {
                window.setTimeout({ mountButton() }, 100)
                return
            }
            val element = document.getElementById(buttonId) as? HTMLElement ?: return
            element.innerHTML = ""
            val options = js("{}")
            options.client_id = clientId
            options.callback = { response: dynamic ->
                window.asDynamic().checkinHandleGoogleCredential(response.credential as String)
            }
            google.accounts.id.initialize(options)
            val buttonOptions = js("{}")
            buttonOptions.theme = "outline"
            buttonOptions.size = "large"
            buttonOptions.width = 360
            buttonOptions.locale = "fr"
            buttonOptions.text = "continue_with"
            google.accounts.id.renderButton(element, buttonOptions)
        }
        mountButton()

        onDispose {
            cancelled = true
            if (credentialHandler === onCredential) {
                credentialHandler = null
            }
        }
    }

    AuthDivider()

    Div({
        style {
            width(100.percent)
            display(DisplayStyle.Flex)
            justifyContent(JustifyContent.Center)
            property("opacity", if (enabled) "1" else "0.6")
            property("pointer-events", if (enabled) "auto" else "none")
        }
    }) {
        Div({ id(buttonId) })
    }
}

@Composable
private fun AuthDivider() {
    Div({
        style {
            display(DisplayStyle.Flex)
            alignItems(AlignItems.Center)
            gap(12.px)
            margin(20.px, 0.px)
        }
    }) {
        Div({
            style {
                flex(1)
                height(1.px)
                backgroundColor(Color("#e5e7eb"))
            }
        })
        Text("ou")
        Div({
            style {
                flex(1)
                height(1.px)
                backgroundColor(Color("#e5e7eb"))
            }
        })
    }
}
